module.exports = __webpack_public_path__ + "img/no_shop_placeholder@2x.f5ee9fe9.png";